import React from 'react';

import {Card, CardContent, Stack, Typography, Box} from 'views/components';
import {Translate, translate, MarkdownViewer} from 'views/module';

const ChoosingYourCaregiverCard = () => {
  return (
    <Card>
      <CardContent>
        <Stack spacing={3}>
          <Stack>
            <Typography component='div' variant='h6'>
              <Translate expression={'dashboard.sections.info.choosingYourCaregiverTitle'}/>
            </Typography>
            <Typography component='div' variant='body2' color='text.secondary'>
              <MarkdownViewer value={translate('dashboard.sections.info.choosingYourCaregiver')}/>
            </Typography>
          </Stack>

          <Box
            display='grid'
            gridTemplateColumns={{
              xs: '1fr',
              sm: 'repeat(2, 1fr)',
            }}
            height='content-fit'
            gap={2}
          >
            <Card sx={{bgcolor: 'background.default', py: 3}}>
              <Stack>
                <Typography component='div' variant='subtitle'>
                  <Translate expression={'dashboard.sections.info.theProcessTitle'}/>
                </Typography>
                <Typography component='div' variant='body2' color='text.secondary'>
                  <MarkdownViewer value={translate('dashboard.sections.info.theProcess')}/>
                </Typography>
              </Stack>
            </Card>
            <Card sx={{bgcolor: 'background.default', py: 3}}>
              <Stack>
                <Typography component='div' variant='subtitle'>
                  <Translate expression={'dashboard.sections.info.careQuiltStandardTitle'}/>
                </Typography>
                <Typography component='div' variant='body2' color='text.secondary'>
                  <MarkdownViewer value={translate('dashboard.sections.info.careQuiltStandard')}/>
                </Typography>
              </Stack>
            </Card>
          </Box>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default ChoosingYourCaregiverCard;
